var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMediaTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.775,
    y1: 0.086,
    x2: 0.148,
    y2: 0.829,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5593fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481,
    stopColor: "#46d5df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3e844"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3207",
    "data-name": "Rectangle 3207",
    width: 32,
    height: 26,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13693",
    "data-name": "Group 13693",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13051",
    "data-name": "Path 13051",
    d: "M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    transform: "translate(12 12)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13880",
    "data-name": "Group 13880",
    transform: "translate(24 27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13880-2",
    "data-name": "Group 13880",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13130",
    "data-name": "Path 13130",
    d: "M15.989,26a20.071,20.071,0,0,1-6.1-.737,10.683,10.683,0,0,1-1.8-.816,1.191,1.191,0,0,1-.618-1.352c.3-1.89.485-3.8.861-5.672a7,7,0,0,1,6.776-5.52,12.815,12.815,0,0,1,3.467.226,7.131,7.131,0,0,1,5.226,5.9c.246,1.7.473,3.4.73,5.095a1.159,1.159,0,0,1-.56,1.281,9.564,9.564,0,0,1-1.656.792,18.045,18.045,0,0,1-5.39.8c-.313.009-.627,0-.941,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13131",
    "data-name": "Path 13131",
    d: "M16.007,11.145a5.573,5.573,0,1,1,5.577-5.58,5.57,5.57,0,0,1-5.577,5.58",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13132",
    "data-name": "Path 13132",
    d: "M22.557,12.76a6.108,6.108,0,0,1,9.07,3.988c.125.625.225,1.255.345,1.881a1.315,1.315,0,0,1-.451,1.282A5.274,5.274,0,0,1,28.86,21.2c-.92.178-1.863.233-2.8.348-.222.028-.269-.08-.3-.273-.175-1.24-.349-2.481-.545-3.718a8.273,8.273,0,0,0-2.332-4.574,2.2,2.2,0,0,0-.334-.227",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13133",
    "data-name": "Path 13133",
    d: "M9.385,12.716A8.034,8.034,0,0,0,7.036,16.49c-.249.925-.362,1.887-.519,2.835-.111.664-.187,1.333-.3,2-.015.087-.146.224-.22.222a9.882,9.882,0,0,1-4.557-.966,6,6,0,0,1-1.1-.833,1.053,1.053,0,0,1-.315-1.021c.136-.753.24-1.514.425-2.255a6.089,6.089,0,0,1,8.6-3.942c.1.051.2.112.342.19",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13134",
    "data-name": "Path 13134",
    d: "M6.335,11.144A4.086,4.086,0,1,1,8.473,3.581a.441.441,0,0,1,.239.557A7.178,7.178,0,0,0,9.49,9.15a.422.422,0,0,1-.056.572,4.061,4.061,0,0,1-3.1,1.422",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13135",
    "data-name": "Path 13135",
    d: "M25.407,11.144a3.921,3.921,0,0,1-2.89-1.491.318.318,0,0,1-.044-.425,7.2,7.2,0,0,0,.8-5.173c-.055-.255.068-.351.247-.462a4.09,4.09,0,0,1,6.015,4.842,4.17,4.17,0,0,1-4.125,2.709",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaTeam);
export default __webpack_public_path__ + "static/media/socialMediaTeam.b4a018d115c658d2d61ec29ef5af8781.svg";
export { ForwardRef as ReactComponent };